"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _spin = _interopRequireDefault(require("spin.js"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** cccisd-spinner provides you with a spinner image. It will be placed in the middle of the parent tag (with relative or absolute position) */
var _default = (0, _pure.default)((_temp = _class =
/*#__PURE__*/
function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_class)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_getOptions", function () {
      var defaultOptions = {
        lines: 10,
        // The number of lines to draw
        length: 5,
        // The length of each line
        width: 3,
        // The line thickness
        radius: 4,
        // The radius of the inner circle
        scale: 1,
        // Scales overall size of the spinner
        corners: 1,
        // Corner roundness (0..1)
        color: '#333',
        // #rgb or #rrggbb or array of colors
        opacity: 0.25,
        // Opacity of the lines
        rotate: 0,
        // The rotation offset
        direction: 1,
        // 1: clockwise, -1: counterclockwise
        speed: 1,
        // Rounds per second
        trail: 60,
        // Afterglow percentage
        fps: 20,
        // Frames per second when using setTimeout() as a fallback for CSS
        zIndex: 2e9,
        // The z-index (defaults to 2000000000)
        className: 'spinner',
        // The CSS class to assign to the spinner
        top: '50%',
        // Top position relative to parent
        left: '50%',
        // Left position relative to parent
        shadow: false,
        // Whether to render a shadow
        hwaccel: false,
        // Whether to use hardware acceleration
        position: 'absolute' // Element positioning

      };
      return Object.assign(defaultOptions, _this.props.options);
    });

    _defineProperty(_assertThisInitialized(_this), "_showSpinner", function () {
      var target = _this.refs.spinner;
      _this.spinner = new _spin.default(_this._getOptions()).spin(target);
    });

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._showSpinner();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.spinner.stop();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("span", {
        ref: "spinner"
      });
    }
  }]);

  return _class;
}(_react.default.Component), _defineProperty(_class, "propTypes", {
  /** Options to alter default behavior: height, width, color, className, radius, etc... see https//spin.js.org for full list */
  options: _propTypes.default.object
}), _defineProperty(_class, "defaultProps", {
  options: {}
}), _temp));

exports.default = _default;